import React, { useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Plot from "react-plotly.js";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";
import Projectcolors from "../Utils/Colors";
import { Typography } from "@mui/material";
import Alert from "@mui/material/Alert";
import { baseURL } from "../Config/config";
import GlobalLoader from "./CommonC/GlobalLoader";

function SliceData(props) {
  const [rawdata, setRawData] = React.useState([]);

  const [lineplotdata, setLineplotdata] = React.useState([]);

  const [lineploty, setLineploty] = React.useState([]);
  const [xrange1, setXrange1] = React.useState(0);
  const [xrange2, setXrange2] = React.useState(0);

  const [slice, setslice] = React.useState(false);
  const [saved, setsaved] = React.useState(false);

  const [ylabel, setYLabel] = React.useState("Y axis");
  const colorslist = [
    "#3366cc",
    "#dc3912",
    "#ff9900",
    "#109618",
    "#990099",
    "#0099c6",
    "#dd4477",
    "#aaaa11",
    "#743411",
    "#e67300",
    "#22aa99",
    "#994499",
    "#22aa99",
    "#66aa00",
    "#6633cc",
    "#3366cc",
    "#8b0707",
    "#651067",
    "#329262",
    "#5574a6",
    "#3b3eac",
    "#b77322",
    "#16d620",
    "#b91383",
    "#f4359e",
    "#9c5935",
    "#a9c413",
    "#2a778d",
    "#668d1c",
    "#bea413",
    "#0c5922",
    "#b82e2e",
  ];
  const [colors, setColors] = React.useState(colorslist[0]);
  const [getLoader, setGetLoader] = React.useState(false);

  useEffect(() => {
    getSlicedData();
  }, [slice]);

  const getSlicedData = () => {
    setGetLoader(true);
    const ProjectID = sessionStorage.getItem("projectID");
    fetch(`${baseURL}/getsliceddata?projectID=${ProjectID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())

      .then((raw) => {
        setRawData(raw.raw_data);
        setLineplotdata(raw.lineplotdata);
        setLineploty(raw.lineplotdata[0]);
        setGetLoader(false);
      })
      .catch((err) => {
        setGetLoader(false);
        console.log("caught it!", err);
      });
  };

  function handlerowclick(number) {
    setLineploty(lineplotdata[number]);
    setYLabel(rawdata[number][1]);
    setColors(colorslist[number]);

  }

  const getsliderdata = (eventdata) => {
    
    setslice(false);

    setXrange1(Math.round(eventdata["xaxis.range[0]"]));
    setXrange2(Math.round(eventdata["xaxis.range[1]"]));
  };


  const slicedata = () => {
    setGetLoader(true);
    const ProjectID = sessionStorage.getItem("projectID");

    const body = {
      x1: xrange1,
      x2: xrange2,
      ProjectID: ProjectID,
    };

    try {
      fetch(`${baseURL}/saveslicedata`, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((result) => {
          setslice(true);
          setsaved(false);
          setGetLoader(false);
        })
        .catch((error) => {
          console.error("Error:", error);
          setGetLoader(false);
        });
    } catch (error) {
      console.log("error", error);
      setGetLoader(false);
    }
  };

  const undodata = () => {
    const ProjectID = sessionStorage.getItem("projectID");
    setGetLoader(true);
    try {
      fetch(`${baseURL}/undodata?projectID=${ProjectID}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((result) => {
          setslice(false);
          setGetLoader(false);
          getSlicedData();

        })
        .catch((error) => {
          console.error("Error:", error);
          setGetLoader(false);
        });
    } catch (error) {
      console.log("error", error);
      setGetLoader(false);
    }
  };

  const savedata = () => {
    setsaved(true);
    setslice(false);
  };

  const selectorOptions = {
    buttons: [
      {
        step: "month",
        stepmode: "backward",
        count: 1,
        label: "1m",
      },
      {
        step: "month",
        stepmode: "backward",
        count: 6,
        label: "6m",
      },
      {
        step: "year",
        stepmode: "todate",
        count: 1,
        label: "YTD",
      },
      {
        step: "year",
        stepmode: "backward",
        count: 1,
        label: "1y",
      },
      {
        step: "all",
      },
    ],
  };

  return (
  <Box sx={{ px: 2, py: 2 }}>
    
    {/* TABLE CARD */}
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: "22px",
        bgcolor: "#fff",
        boxShadow: "0px 8px 30px rgba(0,0,0,.06)",
        mb: 2
      }}
    >
      <TableContainer
        sx={{
          height: 250,
          borderRadius: "14px",
          overflow: "auto",
          border: "1px solid rgba(0,120,201,.15)"
        }}
      >
        <Table stickyHeader>

          <TableHead>
            <TableRow>
              {["Tag Name", "Description", "Unit Of Measure"].map(
                (item) => (
                  <TableCell
                    key={item}
                    sx={{
                      backgroundColor:"#0078c9",
                      color:"#fff",
                      fontSize:"12px",
                      fontWeight:600
                    }}
                  >
                    {item}
                  </TableCell>
                )
              )}
            </TableRow>
          </TableHead>

          <TableBody>
            {rawdata?.map((item,i)=>(
              <TableRow
                key={i}
                hover
                onClick={()=>handlerowclick(i)}
                sx={{
                  cursor:"pointer",

                  "&:hover":{
                    background:"#f5f9ff"
                  }
                }}
              >
                {item.map((data,idx)=>(
                  <TableCell
                    key={idx}
                    sx={{
                      fontSize:"12px",
                      py:1.5
                    }}
                  >
                    {data}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>

        </Table>
      </TableContainer>
    </Paper>


    {/* GRAPH CARD */}

    <Paper
      elevation={0}
      sx={{
        p:2,
        borderRadius:"22px",
        bgcolor:"#fff",
        boxShadow:
          "0px 8px 30px rgba(0,0,0,.06)",
        mb:2
      }}
    >

      <Plot
        data={[
          {
            x:Array.from(
              Array(lineploty.length).keys()
            ),
            y:lineploty,
            type:"line",
            mode:"lines+markers",
            marker:{
              color:"#0078c9"
            }
          }
        ]}

        layout={{
          autosize:true,
          width:850,
          height:200,

          margin:{
            l:60,
            r:20,
            t:30,
            b:50
          },

          paper_bgcolor:"white",
          plot_bgcolor:"white",

          xaxis:{
            title:{
              text:"Count",
              font:{size:12}
            },

            rangeslider:{
              visible:true,
              bgcolor:"#eef6fc",
              thickness:.08
            }
          },

          yaxis:{
            title:{
              text:ylabel,
              font:{size:12}
            }
          }
        }}

        onRelayout={getsliderdata}

        config={{
          displaylogo:false,
          responsive:true
        }}
      />

    </Paper>


    {/* FOOTER */}

    <Box
      sx={{
        display:"flex",
        justifyContent:"space-between",
        alignItems:"center",
        flexWrap:"wrap",
        gap:2
      }}
    >

      <Box>

        <Typography
          sx={{
            fontSize:"12px"
          }}
        >
          Start Slice Out:
          <b> {xrange1}</b>
        </Typography>

        <Typography
          sx={{
            fontSize:"12px"
          }}
        >
          End Slice Out:
          <b> {xrange2}</b>
        </Typography>

      </Box>


      <Box
      sx={{
        display:"flex",
        gap:1
      }}
      >

      {slice && (

        <Alert
        severity="success"
        sx={{
          borderRadius:"12px",
          fontSize:"12px"
        }}
        >
          Data Sliced Successfully
        </Alert>

      )}

      {saved && (

        <Alert
        severity="success"
        sx={{
          borderRadius:"12px",
          fontSize:"12px"
        }}
        >
          Data Saved
        </Alert>

      )}

      </Box>


      <Box
      sx={{
        display:"flex",
        gap:1
      }}
      >

        {["Apply","Undo","Save"].map((label,index)=>(

          <Button
            key={label}
            onClick={
              index===0
              ? slicedata
              : index===1
              ? undodata
              : savedata
            }

            disabled={!props.editAccess}

            variant="contained"

            sx={{
              background:"#0078c9",
              borderRadius:"12px",
              fontSize:"12px",
              px:3,
              height:42,

              boxShadow:
                "0px 8px 18px rgba(0,120,201,.2)",

              "&:hover":{
                background:"#0065aa"
              }
            }}
          >
            {label}
          </Button>

        ))}

      </Box>

    </Box>

    {getLoader && <GlobalLoader/>}

  </Box>
)
}

export default SliceData;
